import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon } from 'lucide-react';
import { Reveal } from '../Reveal';
import { img } from '../../data/site';
export function Statement() {
  return <section className="mx-auto max-w-shell px-5 py-16 sm:px-6 lg:px-10 lg:py-28" data-id="element-628" data-mp="2uwgtg56qc9ym">
      <div className="grid gap-10 lg:grid-cols-[minmax(0,1.05fr)_minmax(0,1fr)] lg:gap-20" data-id="element-629" data-mp="2zvjn6th9etra">
        <Reveal data-id="element-630" data-mp="228b8bhbrkiy9">
          <span className="flex items-center gap-3" data-id="element-631" data-mp="228kx51l2ok2d">
            <span className="hairline h-px w-10" aria-hidden="true" data-id="element-632" data-mp="225yi6gvur2a4" />
            <span className="text-[11px] uppercase tracking-[0.28em] text-ember" data-id="element-633" data-mp="277xnhwb5k99p">De studio</span>
          </span>
          <h2 className="mt-5 font-display text-3xl font-extrabold leading-[1.05] tracking-tightest text-chalk sm:text-4xl" data-id="element-634" data-mp="2c4nxq30a0an7">
            Een jong, dynamisch team met één obsessie.
          </h2>
          <p className="mt-5 max-w-lg text-[15px] leading-relaxed text-dim" data-id="element-635" data-mp="1jh1wv2ifnk41">
            Passie, kwaliteit en service is waar wij voor staan en wat ons onderscheidt van overige autowasstraten
            en poetsbedrijven. Wij bespreken altijd eerst wat het beste is voor uw voertuig en werken flexibel op
            afspraak.
          </p>
          <Link to="/studio" className="group mt-8 inline-flex items-center gap-2 text-sm font-medium text-ember transition-colors duration-200 ease-smooth hover:text-chalk" data-id="element-636" data-mp="2idixu88pfl4f">
            Kijk binnen in de studio
            <ArrowRightIcon className="h-4 w-4 transition-transform duration-200 ease-smooth group-hover:translate-x-0.5" aria-hidden="true" data-id="element-637" data-mp="29dm61xr0q655" />
          </Link>
        </Reveal>

        <Reveal delay={0.06} className="grid grid-cols-2 gap-4" data-id="element-638" data-mp="1zewxivl0hy1k">
          <img src={img.wheel} alt="Gereinigde velg na een volledige behandeling" className="col-span-2 h-52 w-full rounded-2xl border border-edge object-cover lg:h-64" data-id="element-639" data-mp="1ugn3iob0x3hj" />
          <img src={img.interior} alt="Interieur van een gezinsauto na reiniging" className="h-40 w-full rounded-2xl border border-edge object-cover lg:h-52" data-id="element-640" data-mp="3ouwayovny9n0" />
          <img src={img.wash} alt="Handmatig wassen van een auto in de studio" className="h-40 w-full rounded-2xl border border-edge object-cover lg:h-52" data-id="element-641" data-mp="1rwqe98207xrd" />
        </Reveal>
      </div>
    </section>;
}